/**
 * Validates that `next` is a safe in-app path (exactly one leading `/`, no
 * protocol-relative `//`) so magic-link redirects can't act as open redirects.
 */
export function isSafeNextPath(next) {
    if (typeof next !== "string" || next.length === 0)
        return false;
    if (!next.startsWith("/"))
        return false;
    if (next.startsWith("//"))
        return false;
    return true;
}
//# sourceMappingURL=safeNextPath.js.map